import { createFileRoute } from '@tanstack/react-router'
import { TicketCategoriesPage } from '@/features/tickets/components/ticket-categories'

export const Route = createFileRoute('/_authenticated/ticket-categories/')({
  component: TicketCategoriesPage,
})
